<div class="si-delete-button">
  <button class="{{styleClass | translate}}"
          type="button"
          (click)="onClickButton($event)">
    <i class="{{icon}} mr-2" *ngIf="icon"></i>
    <span>{{text | translate}}</span>
  </button>
  <si-generic-dialog [displayDialog]="displayDialog"
                     [dialogTitle]="dialogTitle"
                     [dialogTitleStyleClass]="dialogTitleStyleClass"
                     [dialogText]="dialogText"
                     [button1Text]="button1Text"
                     [button1Class]="button1Class"
                     [button2Text]="button2Text"
                     [button2Class]="button2Class"
                     (updateButton1Change)="onClickCloseDialog(true)"
                     (updateButton2Change)="onClickCloseDialog(false)"
                     (displayDialogChange)="onChangeDisplayDialog($event)"
  ></si-generic-dialog>
</div>
